import { render, staticRenderFns } from "./PropertySlider.vue?vue&type=template&id=b6025ac2"
import script from "./PropertySlider.vue?vue&type=script&lang=js"
export * from "./PropertySlider.vue?vue&type=script&lang=js"
import style0 from "./PropertySlider.vue?vue&type=style&index=0&id=b6025ac2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports